export default __webpack_public_path__ + "static/media/tileroof.cf6b5039.jpeg";